import { gql } from '../../../../../hooks'

export const DELETE_MODELS = gql`
  mutation AdministrationDeleteComponentModels($id: ID!) {
    aDelete(path: "component/models", id: $id) {
    }
  }
`

export const LIST_MODELS = gql`
  query AdministrationListComponentModels(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "component/models"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
